import { render, staticRenderFns } from "./area_select.vue?vue&type=template&id=92b620cc&"
import script from "./area_select.vue?vue&type=script&lang=js&"
export * from "./area_select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports